module.exports = __webpack_public_path__ + "static/media/redeemly-logo.546a3149.jpeg";